import styled from '@emotion/styled'

const Wrapper = styled.div`
  width: 100%;
  padding: ${({ padding }) => padding || '0rem'};
  position: relative;
  overflow: hidden;
`
export default Wrapper
